import {
  Button,
  Pagination,
  Table,
  Tag,
  Input,
  message,
  Switch,
  Space,
  Popconfirm,
  Image,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ExtractDate, ExtractTime, messageConfiguration } from "../../../utils";
import "animate.css";
import { useNavigate } from "react-router-dom";
import ComponentTitle from "../../../Common/ComponentTitle";
import {
  deleteProperty,
  getProperties,
  modifyStatus,
} from "./PropertiesapiFunctions";
import {
  DeleteOutlined,
  EditOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import Highlighter from "react-highlight-words";

const Properties = () => {
  const [requestsData, setRequestsData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalPage, setTotalPages] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const pageSize = 10;
  const searchInput = useRef(null);
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const { Search } = Input;

  function FetchProperties(currentPage) {
    setIsLoading(true);

    let queryParams = `page=${currentPage}&search=${searchTerm}`;
    if (searchText && searchedColumn) {
      queryParams += `&${searchedColumn}=${searchText}`;
    }

    getProperties(queryParams)
      .then((response) => {
        if (response.status) {
          setRequestsData(response.data?.data);
          setCurrentPage(response.data?.pagination?.currentPage);
          setTotalPages(response.data?.pagination?.totalPages);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        console.log("error", err);
        setIsLoading(false);
      });
  }

  useEffect(() => {
    FetchProperties(currentPage);
  }, [currentPage, searchText, searchedColumn, searchTerm]);

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
  };
  function ModifyUserStatus(checked, record) {
    console.log(checked, record);
    modifyStatus(`${record.id}`)
      .then((response) => {
        if (response.status) {
          console.log(response.data?.status);
          {
            checked === false
              ? setRequestsData((prevData) =>
                  prevData.map((item) =>
                    item.id === record.id
                      ? {
                          ...item,
                          status: "Inactive",
                        }
                      : item
                  )
                )
              : setRequestsData((prevData) =>
                  prevData.map((item) =>
                    item.id === record.id
                      ? {
                          ...item,
                          status: "Active",
                        }
                      : item
                  )
                );
          }

          FetchProperties();

          message.open(
            messageConfiguration("success", response.data.message, 1)
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    setCurrentPage(1);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: "white",
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  function DeleteAction(checked, record) {
    deleteProperty(`${record.id}`)
      .then((response) => {
        if (response.data.status) {
          message.open(
            messageConfiguration("success", response.data.message, 3)
          );
          FetchProperties(currentPage);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const columnReports = [
    {
      title: "SNo.",
      dataIndex: "serial",
      key: "serial",
      className: "custom-header font-poppins text-xs",
      render: (data, record, index) => {
        return (
          <p className="text-xs font-poppins text-rgbaprimary9 font-semibold">
            {index + 1 + (currentPage - 1) * pageSize}.
          </p>
        );
      },
    },
    {
      title: "Thumbnail Image",
      dataIndex: "thumbnailPath",
      key: "thumbnailPath",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        const thumbnail =
          record.images.find((image) => image.thumbnailPath) || {};

        return (
          <>
            {record.isPlot ? (
              <Tag className="font-bold bg-white w-full text-rgbaprimary9 flex justify-center border-rgbaprimary9">
                No Thumbnail
              </Tag>
            ) : thumbnail.thumbnailPath ? (
              <Image
                src={
                  thumbnail.thumbnailPath
                    ? `${process.env.REACT_APP_IMAGE_URL}${thumbnail.thumbnailPath}`
                    : ""
                }
                height={100}
                width={150}
                alt="Thumbnail"
              />
            ) : (
              <Tag className="font-bold bg-white w-full text-rgbaprimary9 flex justify-center border-rgbaprimary9">
                No Thumbnail
              </Tag>
            )}
          </>
        );
      },
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {record.title?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      // ...getColumnSearchProps("type"),

      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record.type ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "Created By",
      dataIndex: "userName",
      key: "userName",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">{record.userName ?? "--"}</p>
          </>
        );
      },
    },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
      // ...getColumnSearchProps("city"),

      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs  font-poppins">
              {record.city?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "State",
      dataIndex: "state",
      key: "state",
      // ...getColumnSearchProps("state"),

      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs  font-poppins">
              {record.state?.toUpperCase() ?? "--"}
            </p>
          </>
        );
      },
    },
    {
      title: "Construction Status",
      dataIndex: "constructionStatus",
      key: "constructionStatus",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return record.constructionStatus === "Ongoing" ? (
          <Tag className="font-bold bg-rgbaprimary2 text-white w-full flex justify-center border-rgbaprimary2">
            Ongoing
          </Tag>
        ) : (
          <Tag className="font-bold bg-rgbaprimary9 w-full text-white flex justify-center border-rgbaprimary9">
            Done
          </Tag>
        );
      },
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p className="text-xs font-poppins">
              {ExtractDate(record.createdAt)}.{ExtractTime(record.createdAt)}
            </p>
          </>
        );
      },
    },
    {
      title: "View",
      dataIndex: "createdAt",
      key: "createdAt",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p
              className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-gray-500"
              title="View details"
              onClick={() => {
                navigate("/showDetails", {
                  state: {
                    record: record,
                  },
                });
              }}
            >
              ...
            </p>
          </>
        );
      },
    },
    {
      title: "Action",
      key: "status",
      dataIndex: "status",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <Switch
            className={
              record.status === "Active" ? "switch-active" : "switch-inactive"
            }
            checked={record.status === "Active"}
            checkedChildren="Active"
            unCheckedChildren="Inactive"
            onChange={(checked) => ModifyUserStatus(checked, record)}
          />
        );
      },
    },
    {
      title: "Edit",
      dataIndex: "edit",
      key: "edit",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => {
        return (
          <>
            <p
              className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
              title="View details"
              onClick={() => {
                navigate("/createProperty", {
                  state: {
                    record: record,
                    from: "edit",
                    apiCall: FetchProperties(),
                  },
                });
              }}
            >
              <EditOutlined />
            </p>
          </>
        );
      },
    },
    {
      title: "Delete",
      dataIndex: "delete",
      key: "delete",
      className: "custom-header font-poppins text-xs",
      render: (data, record) => (
        <Popconfirm
          title={
            <div>
              <p style={{ marginBottom: "8px", fontWeight: "bold" }}>
                Are you sure you want to delete this Property?
              </p>
            </div>
          }
          onConfirm={() => DeleteAction(undefined, record)}
          okText="Delete"
          cancelText="Cancel"
        >
          <DeleteOutlined
            className="text-xs font-poppins font-bold w-1/2 text-center rounded-full cursor-pointer text-rgbaprimary9"
            title="Delete"
          />
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <ComponentTitle title={"Properties List"} />
      <div className="flex items-end justify-between mb-4">
        <Search
          placeholder="Search Title and Description here..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ width: "25%" }}
        />
        <p
          onClick={() => {
            navigate("/createProperty", {
              state: {
                record: "",
                from: "add",
              },
            });
          }}
          className="bg-rgbaprimary9 cursor-pointer text-white text-sm p-2 hover:bg-rgbaprimary8"
        >
          Create Property
        </p>
      </div>

      <div
        style={{ overflow: "auto" }}
        className="bg-white shadow-md  shadow-[rgba(149, 157, 165, 0.2) 0px 8px 24px ] h-[75vh] sm:h-[70vh] md:[60vh] lg:[20vh] "
      >
        <Table
          bordered={true}
          loading={isLoading}
          columns={columnReports}
          dataSource={requestsData}
          pagination={false}
          className="w-screen sm:w-screen custom-table-header "
          size="small"
        />
      </div>
      <Pagination
        className="mt-2 text-xs w-full flex justify-center items-center"
        onChange={handlePageChange}
        current={currentPage}
        defaultCurrent={1}
        total={10 * totalPage}
        showSizeChanger={false}
        pageSize={pageSize}
      />
    </div>
  );
};
export default Properties;
